$(function(){
  $(".concept_slider").slick({
    slidesToShow: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 0,
    speed: 20000,
    pauseOnHover: false,
    centerMode: true,
    infinite: true,
    cssEase: 'linear',
  });
  $(".sp_bnr_slider").slick({
    slidesToShow: 1,
    autoplay: true,
    arrows: false,
    dots: true,
    autoplaySpeed: 3000,
    speed: 3000,
    pauseOnHover: false,
  });
});

jQuery(function() {
  var footer = $('.Footer').innerHeight(); // footerの高さを取得
  window.onscroll = function () {
    var point = window.pageYOffset; // 現在のスクロール地点 
    var docHeight = $(document).height(); // ドキュメントの高さ
    var dispHeight = $(window).height(); // 表示領域の高さ
    if(point > docHeight-dispHeight-footer){ // スクロール地点>ドキュメントの高さ-表示領域-footerの高さ
      $('.floating_box').addClass('is-hidden'); //footerより下にスクロールしたらis-hiddenを追加
      $('.right_floating_box').addClass('is-hidden'); //footerより下にスクロールしたらis-hiddenを追加
    }else{
      $('.floating_box').removeClass('is-hidden'); //footerより上にスクロールしたらis-hiddenを削除
      $('.right_floating_box').removeClass('is-hidden'); //footerより上にスクロールしたらis-hiddenを削除
    }
  };
});

jQuery(function($){
  $('.js-img-click-swap').each(function(){
    const $root = $(this);
    const $imgs = $root.find('.img-click-swap__img');
    if ($imgs.length < 2) return;

    let idx = $imgs.filter('.is-active').index();
    if (idx < 0) idx = 0;

    function show(i){
      $imgs.removeClass('is-active').eq(i).addClass('is-active');
      idx = i;
    }

    $root.on('click', function(){
      const next = (idx + 1) % $imgs.length;
      show(next);
    });
  });
});